'use client';

import Button from '@/components/atoms/button';
import React, { useCallback, useState } from 'react';
import { ChatBubbleOvalLeftEllipsisIcon as ChatBubble } from '@heroicons/react/24/outline';
import Link from '@/components/atoms/link';
import { useParams, usePathname } from 'next/navigation';
import Modal from '../modal';
import useMediaQuery from '@/hooks/useMediaQuery';
import { desktop } from '@/constants/screensizes';
import { FEEDBACK_URL } from '@/constants/envVariables';
import useAccount from '@/lib/hooks/useAccount';

const FeedbackButton = () => {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const [isDesktopSize] = useMediaQuery(desktop);
  const { locale } = useParams();
  const { account } = useAccount();

  const isLoginPage = pathname.includes('/login');
  const isContactUsPage = pathname.includes('/contact-us/');
  const isCreateProfile = pathname.includes('/create-profile/');

  if (isLoginPage || isContactUsPage || isCreateProfile) return null;
  const firstName = account?.firstName || '';
  const surname = account?.lastName || '';
  const email = account?.email || '';
  
  return (
    <div className="child-comp fixed bottom-1/2 right-3.5 z-50 translate-x-1/2 -rotate-90 transform lg:bottom-0 lg:right-4 lg:translate-x-0 lg:rotate-0">
      <Button
        className="gap-1 cursor-pointer  border border-black !bg-[#e5e9eb] !px-2 !py-1 !text-10 !text-black hover:bg-gray-200 md:py-1 md:!text-12"
        Icon={ChatBubble}
        iconClassName="w-[20px] h-[20px]"
        iconPosition="left"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        Share Feedback
      </Button>

      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={{
          content: {
            backgroundColor: 'white',
            padding: '5px',
            height: isDesktopSize ? '77.5vh' : '65vh',
            maxWidth: isDesktopSize ? 'auto' : '90%',
          },
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
        }}
        closeButton={true}
        className="border-transparent focus:border-transparent focus:outline-none focus:ring-0 [&>svg]:!text-white [&>svg]:hover:!text-white [&>svg]:bg-gray-700 [&>svg]:hover:!bg-gray-700"
      >
        {typeof window !== 'undefined' && (
          <embed
            className="h-full w-full"
            src={encodeURI(`${FEEDBACK_URL},"Source":"${encodeURIComponent(`${window.location.origin}/${locale}`)}","FirstName":"${encodeURIComponent(firstName)}","Surname":"${encodeURIComponent(surname)}","Email":"${encodeURIComponent(email)}"}`)}
          ></embed>
        )}
      </Modal>      
    </div>
  );
};

export default FeedbackButton;
